import React, { Component } from 'react';
import CheckerManager from './components/CheckerManager';

class App extends Component {
  render() {
    return (
      <div>
        <CheckerManager />
      </div>
    );
  }
}

export default App;
